import { useState } from "react"
import ChoosePlanData from "../../Configs/JSON/ChoosePlan.json"
import "./ChoosePlan.less"
import { Accordion } from "./Accordion"
import Image from "../Common/Image/Image"

const ChoosePlan = () => {
  const [question, setQuestion] = useState(1)
  const [accordionkey, setAccordionKey] = useState(1)

  const questionHandler = (key) => {
    setQuestion(key)
  }

  const toggleAccordion = (key) => {
    setAccordionKey((prev) => prev === key ? null : key)
  }

  return (
    <>
      <div className="ChoosePlan_Parent">
        <div className="ChoosePlan_wrapper">
          <h2>How do I choose a pension plan?</h2>
          <span className="ChoosePlan_subtitle">
            Selecting the right pension plan is essential to ensure you have enough money to enjoy your financial freedom during your golden years.
            Below are some things that can you do to select a suitable pension plan:
          </span>
          <div className="ChoosePlan_content_desktop">
            <div className="ChoosePlan_left">
              {ChoosePlanData.data.map((item,index) => (
                <div key={index} className={`ChoosePlan_question ${question === item.key && `questionActive`}`} onClick={() => questionHandler(item.key)}>
                  <span className="ChoosePlan_position">{item.key}</span>
                  <h3 className={`ChoosePlan_questionTitle ${question === item.key && `questionActiveTitle`}`}>{item.title}</h3>
                  <Image  src={"assets/Expand_red.svg"} className={`ChoosePlan_expandIcon ${question === item.key && `activeExpand`}`}  alt="right_arrow_image" />
                </div>
              ))}
            </div>
            <div className="ChoosePlan_right">
              {ChoosePlanData.data.map(
                (item,index) =>
                  question === item.key && (
                    <div className="ChoosePlan_rightwrapper" key={index}>
                      <span className="ChoosePlan_rightPosition">{item.key}</span>
                      <span className="ChoosePlan_rightTitle" dangerouslySetInnerHTML={{ __html: item.title }}>
                      </span>
                      <span dangerouslySetInnerHTML={{ __html: item.content }}></span>
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="ChoosePlan_content_mobile">
            <div className="ChoosePlan_accordionParent">
              {ChoosePlanData.data.map((item,index) => (
                <Accordion item={item} isActive={accordionkey === item.key} toggleAccordion={toggleAccordion} key={index}/>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChoosePlan
